import { Budget } from 'types/executiveStatistics';
import AgencyService from 'services/agenciesService';

const getBudgetStatistics = async (
  getAuthToken: () => Promise<string>
): Promise<Budget[] | undefined> => {
  const token = await getAuthToken();
  const service = new AgencyService(token);

  const result = await service.agencyService.get('GetExecutiveKeyBudget');
  return result.data || [];
};

export default getBudgetStatistics;
